import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel, ConsultaSeguimentoOutroFieldModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta03ExemplosEnum {
  BEBIA_XICARA_BRINQUEDO = 'BEBIA_XICARA_BRINQUEDO',
  COMIA_COLHER_BRINQUEDO = 'COMIA_COLHER_BRINQUEDO',
  FALAVA_TELEFONE = 'FALAVA_TELEFONE',
  DAVA_COMIDA = 'DAVA_COMIDA',
  EMPURRAR_CARRO = 'EMPURRAR_CARRO',
  PERSONAGENS_FAVORITOS = 'PERSONAGENS_FAVORITOS',
  PANELA_FOGAO = 'PANELA_FOGAO',
  MEXEU_COMIDA = 'MEXEU_COMIDA',
  MOTORISTA_PASSAGEIRO = 'MOTORISTA_PASSAGEIRO',
  ASPIRAVA_VARRIA_CORTAVA = 'ASPIRAVA_VARRIA_CORTAVA',
}

export interface ConsultaSeguimentoPergunta03Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_03_HEADER?: SimNaoEnum
  PERGUNTA_03_EXEMPLOS?: Record<ConsultaSeguimentoPergunta03ExemplosEnum, SimNaoEnum | undefined>
  OUTRO?: ConsultaSeguimentoOutroFieldModel
}
